import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { API_ENDPOINTS } from '../utils/api.constants';
import { LoginRequest, MeResponse, RefreshRequest, SsoLoginRequest, TokenResponse } from '../models/auth.model';

@Injectable({
  providedIn: 'root'
})
export class LoginService {

  constructor(private http: HttpClient) { }

  login(payload: LoginRequest): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(API_ENDPOINTS.AUTH.LOGIN, payload);
  }

  refreshToken(payload: RefreshRequest): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(API_ENDPOINTS.AUTH.REFRESH_TOKEN, payload);
  }

  getMe(): Observable<MeResponse> {
    return this.http.get<MeResponse>(API_ENDPOINTS.AUTH.ME);
  }

  ssoLogin(payload: SsoLoginRequest): Observable<TokenResponse> {
    return this.http.post<TokenResponse>(API_ENDPOINTS.AUTH.SSO_LOGIN, payload);
  }
}
